module.exports = __webpack_public_path__ + "static/media/handball.8778559b.svg";